class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('mouseover', this.onMouseOver.bind(this));
    this.mainDetailsToggle.addEventListener('mouseout', this.onMouseOut.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onMouseOver() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (!this.mainDetailsToggle.hasAttribute('open')) {
      this.mainDetailsToggle.setAttribute('open', '');
      this.animations.forEach((animation) => animation.play());
    }
  }

  onMouseOut() {
    if (this.animations) {
      this.animations.forEach((animation) => animation.cancel());
    }
    this.mainDetailsToggle.removeAttribute('open');
    this.header.preventHide = this.mainDetailsToggle.hasAttribute('open');
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

/**
 * 适配动画效果，包裹于原生 <details>
 * 类名 details-opening 标记 details 正在开启的过渡动画中
 * 类名 details-opening 标记 details 正在关闭的过渡动画中
 */
class AnimationDetails extends HTMLElement {
  maxElapsedTime = 200;

  constructor() {
    super();
  }

  init() {
    this.mainDetailsToggle = this.querySelector('details');
    this.summary = this.querySelector('summary');
    this.content = this.summary.nextElementSibling;

    // Recheck the open state when the component is connected
    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.openDetails();
    } else {
      this.closeDetails();
    }

    this._onSummaryClick = this.onSummaryClick.bind(this);
    this.summary.addEventListener('click', this._onSummaryClick);
  }

  connectedCallback() {
    this.init();

    // Observe changes to the element's children
    this.observer = new MutationObserver(() => {
      this.summary.removeEventListener('click', this._onSummaryClick);
      this.init();
    });
    this.observer.observe(this, { childList: true, subtree: true });
  }

  disconnectedCallback() {
    this.summary.removeEventListener('click', this._onSummaryClick);
  }

  onSummaryClick(event) {
    const isOpen = this.mainDetailsToggle.hasAttribute('open');
    const isOpening = this.mainDetailsToggle.classList.contains('details-opening');
    const isClosing = this.mainDetailsToggle.classList.contains('details-closing');
    if (isOpening || isClosing) {
      event.preventDefault();
      return false;
    } else if (isOpen) {
      this.closeDetails();
      event.preventDefault();
    } else {
      this.openDetails();
    }
  }

  openDetails() {
    setTimeout(() => {
      this.mainDetailsToggle.setAttribute('open', '');
      this.mainDetailsToggle.classList.add('details-opening');
      this.mainDetailsToggle.style.height = this.content.clientHeight + this.summary.clientHeight + 'px';
      this.summary.setAttribute('aria-expanded', true);
    });
    setTimeout(() => {
      this.mainDetailsToggle.classList.remove('details-opening');
    }, this.maxElapsedTime);
  }

  closeDetails() {
    this.mainDetailsToggle.classList.remove('details-opening');
    this.mainDetailsToggle.classList.add('details-closing');
    this.mainDetailsToggle.style.height = this.summary.clientHeight + 'px';
    this.closeAnimation(this.mainDetailsToggle);
  }

  closeAnimation() {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < this.maxElapsedTime) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        this.mainDetailsToggle.removeAttribute('open');
        this.mainDetailsToggle.classList.remove('details-opening');
        this.mainDetailsToggle.classList.remove('details-closing');
        if (this.mainDetailsToggle.closest('details[open]')) {
          trapFocus(this.mainDetailsToggle.closest('details[open]'), this.mainDetailsToggle.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}
customElements.define('animation-details', AnimationDetails);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.megaMenuLinksLevel2 = this.querySelectorAll('.mega-menu__link--level-2.mega-menu__link_4level');
    this.megaMenuListLevel3Outer = this.querySelector('.mega-menu__list-level-3-outer');
    if (this.megaMenuListLevel3Outer) {
      this.megaMenuLinkboxesLevel3 = this.megaMenuListLevel3Outer.querySelectorAll('.mega-menu__list-level-3-linkbox');
    } else {
      this.megaMenuLinkboxesLevel3 = [];
    }
    this.addMegaMenuEventListeners();
  }

  onMouseOver() {
    super.onMouseOver();
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.hasAttribute('open');

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  onMouseOut() {
    super.onMouseOut();

  }

  addMegaMenuEventListeners() {
    this.megaMenuLinksLevel2.forEach((link, index) => {
      link.addEventListener('mouseover', () => this.level2MouseOver(index));
    });
  }

  level2MouseOver(index) {
    this.megaMenuLinksLevel2.forEach((link, idx) => {
      if (idx === index) {
        link.classList.add('active');
      } else {
        link.classList.remove('active');
      }
    });

    this.megaMenuLinkboxesLevel3.forEach((box) => {
      if (box.getAttribute('data-index') == index) {
        box.classList.add('active');
      } else {
        box.classList.remove('active');
      }
    });
  }
}

customElements.define('header-menu', HeaderMenu);
